import React from "react";
import "./department.scss";
import { getValue } from "@utils/lodash";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { getFirstLetterOfEachString } from "@common/text-helpers";
import EditSvgComponent from "@assets/svg-components/edit";
import DeleteSvgComponent from "@assets/svg-components/delete";
import { getColorStyle } from "@common/color";
import ProfileCircle from "@components/ProfileCircle";

function DepartmentTable(props: any) {
  return (
    <div>
      <table className="datatable_table">
        <thead className="datatable_table_thead">
          <th className="datatable_table_th" style={{ width: "70px" }}>
            <label className="m-0 position-relative" htmlFor="header-checkbox">
              <input
                type="checkbox"
                className="default-checkbox"
                id="header-checkbox"
                onChange={() =>
                  props.handleCheckAll(
                    getValue(props, `departmentList.length`, 0) ===
                      getValue(props, `selectedIDs.length`, 0)
                      ? "All"
                      : "None"
                  )
                }
                checked={
                  getValue(props, `departmentList.length`, 0) ===
                  getValue(props, `selectedIDs.length`, 0)
                }
              />
              <div className="custom-checkbox">
                <img
                  src="/images/uploaded-details/tick.svg"
                  className="img-fluid uploaded-tick"
                />
              </div>
            </label>
          </th>
          <th className="datatable_table_th">
            <h6 className="department_table_h6">Department Name</h6>
          </th>
          <th className="datatable_table_th">
            <h6 className="department_table_h6">Department Code</h6>
          </th>
          <th className="datatable_table_th">
            <h6 className="department_table_h6">Department Head</h6>
          </th>
          {/* <th className="datatable_table_th">
            <h6 className="department_table_h6">Total Members</h6>
          </th> */}
          <th className="datatable_table_th" style={{ width: "100px" }}>
            <h6 className="">Status</h6>
          </th>
          <th className="datatable_table_th">
            <h6 className="department_table_h6">Actions</h6>
          </th>
        </thead>
        <tbody className="datatable_table_tbody">
          {getValue(props, `departmentList`, []).map(
            (item: any, index: number) => {
              return (
                <tr key={index} className="datatable_table_tr">
                  <td className="datatable_table_td" style={{ width: "70px" }}>
                    <label
                      className="m-0 position-relative"
                      htmlFor={`header-checkbox-${index}`}
                    >
                      <input
                        type="checkbox"
                        className="default-checkbox"
                        id={`header-checkbox-${index}`}
                        onChange={() =>
                          props.handleCheckUsers(getValue(item, `id`, ""))
                        }
                        checked={getValue(props, `selectedIDs`, []).includes(
                          getValue(item, `id`, "")
                        )}
                      />
                      <div className="custom-checkbox">
                        <img
                          src="/images/uploaded-details/tick.svg"
                          className="img-fluid uploaded-tick"
                        />
                      </div>
                    </label>
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <div className="d-flex">
                      <div>
                        <h6 className=" color_primary">
                          {getValue(item, `department_name`, "")}
                        </h6>
                        {/* <p>{getValue(item, `employee_id`, "")}</p> */}
                      </div>
                    </div>
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <div className="d-flex">
                      <div>
                        <h6 className="">
                          {getValue(item, `department_code`, "")}
                        </h6>
                      </div>
                    </div>
                  </td>
                  <td
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                    className="datatable_table_td"
                  >
                    <div className="d-flex align-items-center">
                      <ProfileCircle
                        name="department_head"
                        item={item}
                        value={getValue(item, `department_head.email`, "")}
                      />
                      <div>
                        <h6 className=" ">
                          {getValue(item, `department_head.name`, "")}
                        </h6>
                        <p className="">
                          {getValue(item, `department_head.email`, "")}
                        </p>
                      </div>
                    </div>
                  </td>
                  {/* <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <h6 className="">
                      {getValue(item, `team_members`, "")}
                    </h6>
                  </td> */}
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <h6
                      className=""
                      style={getColorStyle(
                        getValue(item, `is_active`, false)
                          ? "Active"
                          : "Inactive"
                      )}
                    >
                      {getValue(item, `is_active`, false)
                        ? "Active"
                        : "Inactive"}
                    </h6>
                  </td>

                  <td className="datatable_table_td action-icon-td">
                    {/* <div className="d-flex align-items-center ">
                      <div
                        onClick={() =>
                          props.handleNavigate(getValue(item, `id`, ""))
                        }
                      >
                        <EditSvgComponent />
                      </div>
                      <div
                        onClick={() =>
                          props.handleDeleteFun(
                            getValue(item, `id`, ""),
                            getValue(item, `title`, "")
                          )
                        }
                      >
                        <DeleteSvgComponent />
                      </div>
                    </div> */}
                    {getValue(props, `permissions`, []).includes("update") && (
                      <UncontrolledDropdown
                        className="table-action-icon-wrap me-4"
                        direction="start"
                        container={"body"}
                      >
                        <DropdownToggle>
                          <div className="switch_header__dropdown m-0 align-items-center">
                            <div className="close-image_container action-icon-wrap">
                              <img
                                src={"/images/more.svg"}
                                className=" close_image"
                              />
                            </div>
                          </div>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem>
                            <div
                              className={`more-dropdown-main-item `}
                              onClick={() =>
                                props.handleNavigate(getValue(item, `id`, ""))
                              }
                            >
                              Edit
                            </div>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    )}
                  </td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
}

export default DepartmentTable;
